import React, { useEffect, useState } from "react";
import YearRangeField from "./shared/YearRangeField";
import NotesField from "./shared/NotesField";
import ImageUploadSection from "./shared/ImageUploadSection";
import VariantsSection from "./shared/VariantsSection";
import AutocompleteInput from "../../components/AutocompleteInput";

import ItemPrivacyToggle from "./shared/ItemPrivacyToggle";
import "./CardFormShared.css";
export default function TCGForm({
  card,
  setCard,
  onSubmit,
  onCancel,
  imageFiles,
  setImageFiles,
  previews,
  setPreviews,
  existingImages,
  categories = [],
  subcategories = [],
  isEditing = false,
  isSubmitting = false,
}) {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCard(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const filteredSubcategories = subcategories.filter(
      (sub) => String(sub.category_id) === String(card.category_id)
    );


    useEffect(() => {
      if (isEditing && card.category_id && !card.subcategory_id) {
        // If editing, make sure subcategory is valid for the current category
        const filtered = subcategories.filter(
          (sub) => String(sub.category_id) === String(card.category_id)
        );
        if (filtered.length === 1) {
          setCard(prev => ({ ...prev, subcategory_id: filtered[0].id }));
        }
      }
    }, [isEditing, card.category_id, subcategories, setCard]);


  return (
    <form className="card-form hobbli-collector-form" onSubmit={onSubmit}>
      {/* Category Display */}
    {card.category_id && (
      <div className="category-display">
        <strong>
          Category:{" "}
          {categories.find((c) => String(c.id) === String(card.category_id))?.name || "Unknown"}
        </strong>
      </div>
    )}
      {/* Subcategory Dropdown */}
        <label>Subcategory</label>
        <select
          name="subcategory_id"
          value={card.subcategory_id || ""}
          onChange={handleChange}
          disabled={!card.category_id || filteredSubcategories.length === 0}
        >
          <option value="">Select Subcategory</option>
          {filteredSubcategories.map((sub) => (
            <option key={sub.id} value={sub.id}>
              {sub.name}
            </option>
          ))}
        </select>
      {/* Card Number / Year */}
      <input
        name="card_number"
        placeholder="Card Number"
        value={card.card_number}
        onChange={handleChange}
      />
      <YearRangeField card={card} setCard={setCard} />

      {/* Brand / Set / Name */}
      <AutocompleteInput
        name="brand"
        placeholder="Brand"
        value={card.brand}
        onChange={handleChange}
        rpcName="fuzzy_brand_autocomplete"
      />
      <AutocompleteInput
        name="set_name"
        placeholder="Set"
        value={card.set_name}
        onChange={handleChange}
        rpcName="fuzzy_set_autocomplete"
      />
      <AutocompleteInput
        name="suggested_name"
        placeholder="Card Name"
        value={card.suggested_name}
        onChange={handleChange}
        rpcName="fuzzy_name_autocomplete"
      />

      {/* Variants */}
      <VariantsSection card={card} setCard={setCard} />
{/* Autographed / Graded */}
      <label className="checkbox-label">
        <input
          type="checkbox"
          name="autographed"
          checked={card.autographed}
          onChange={handleChange}
        />{" "}
        Autographed
      </label>
      <label className="checkbox-label">
        <input
          type="checkbox"
          name="graded"
          checked={card.graded}
          onChange={handleChange}
        />{" "}
        Graded
      </label>

      {/* Grading details if graded */}
      {card.graded && (
        <div className="graded-fields">
          <input
            name="grading_company"
            placeholder="Grading Company"
            value={card.grading_company}
            onChange={handleChange}
          />
          <input
            name="grade"
            placeholder="Grade"
            value={card.grade}
            onChange={handleChange}
          />
          <input
            name="cert_number"
            placeholder="Cert Number"
            value={card.cert_number}
            onChange={handleChange}
          />
        </div>
      )}

      {/* Notes */}
      <div className="hobbli-notes-section">

        <NotesField value={card.notes} onChange={handleChange} />

      </div>

      {/* Image Upload */}
      <div className="hobbli-images-section">

        <ImageUploadSection
        imageFiles={imageFiles}
        setImageFiles={setImageFiles}
        previews={previews}
        setPreviews={setPreviews}
        existingImages={existingImages}
      />

      </div>

      {/* Actions */}
      <ItemPrivacyToggle card={card} setCard={setCard} />

      <div className="form-actions">
        <button
          type="submit"
          disabled={isSubmitting}
          style={{
            flex: 1,
            padding: "10px",
            backgroundColor: isSubmitting ? "#999" : "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: isSubmitting ? "not-allowed" : "pointer",
            opacity: isSubmitting ? 0.7 : 1,
            transition: "background-color 0.2s ease, opacity 0.2s ease",
          }}
        >
          {isSubmitting
            ? (isEditing ? "Saving…" : "Inserting…")
            : (isEditing ? "Save Changes" : "Add Card")}
        </button>
        <button
          type="button"
          onClick={onCancel}
          style={{
            flex: 1,
            padding: "10px",
            backgroundColor: "#6c757d",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
          }}
        >
          Cancel
        </button>
      </div>
    </form>
  );
}
